<template>
  <div class="login-content">
    <div class="login-title"></div>
    <div class="login-form">
      <van-cell-group style="width: 100%;">
        <van-field style="margin-top: 20px;color: #ddd;" v-model="username" placeholder="用户名/手机号" size="large" />
        <van-field v-model="password" placeholder="密码" size="large" />
      </van-cell-group>
      <van-button class="submit-btn" :block="true" @click="login">登录</van-button>
      <div class="boottom-btn">
        <span style="float:left;" @click="gotoRegister">无账号？快速注册</span>
        <span style="float: right;">忘记密码</span>
      </div>
    </div>
    <img class="bottom-img" src="../../assets/login/pt1.png" alt="" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      username: '123456',
      password: '123456',
    };
  },
  methods: {
    ...mapActions(['getUserInfo', 'getUserGoodsInfo']),
    async login() {
      let params = {
        userName: this.username,
        password: this.password,
      };
      const data = await this.getUserInfo(params);
      //登录成功
      if (!data.isError) {
        this.$router.push({
          name: 'classify',
        });
        //登录失败
      } else {
        this.$notify({ color: '#fff', background: '#ff3a3d', message: data.data, duration: 800 });
      }
    },
    gotoRegister() {
      this.$router.push({
        name: 'register',
      });
    },
  },
};
</script>

<style lang="scss">
@import 'common/sass/theme.scss';
.login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: url('../../assets/login/bg1.png') center/cover;
  .login-title {
    width: 100%;
    height: 4.5vh;
    margin-top: 12.4vh;
    background: url('../../assets/login/logo.png') no-repeat center/contain;
  }
  .login-form {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 89vw;
    height: 50vh;
    margin-top: 7vh;
    background: #ffffff;
    box-shadow: 0 0 8px 0 rgba(10, 138, 160, 0.1);
    border-radius: 8px;
    .submit-btn {
      position: absolute;
      bottom: 8vh;
      width: 80vw;
    }
    .boottom-btn {
      position: absolute;
      bottom: 10px;
      width: 80vw;
      color: $theme-color;
    }
    .error-mag {
      color: red;
      margin-top: 15px;
      font-size: 14px;
    }
    .van-field__control {
      color: #515a6e;
    }
  }
  .bottom-img {
    position: absolute;
    bottom: 0;
    display: inline-block;
    width: 43vw;
    height: 29vh;
  }
}
</style>
